(function () {
    'use strict';

    angular
        .module('businessPlanExplorerRoutes', [
            'businessPlanExplorerModule',
            'planInitiativeModule',
            'businessPlanningModule',
            'searchV2Module'
        ])
        .config(router);

    router.$inject = ['$stateProvider', 'searchV2ServiceProvider', 'historyCtxtServiceProvider'];

    function router($stateProvider, searchV2ServiceProvider, historyCtxtServiceProvider) {

        historyCtxtServiceProvider.setCtxtState('businessPlanExplorer',
            '/app/Main/search/GOVHistoryCtxtDirective-searchResults.tpl.html');

        $stateProvider
            .state('businessPlanExplorerDefaults', {
                abstract: true,
                url: '/BusinessPlan',
                views: {
                    '': {
                        template: '<div ui-view="mainContent"></div>'
                    }
                }
            })

            .state('businessPlanExplorer', {
                parent: 'businessPlanExplorerDefaults',
                url: '/Explorer?' + searchV2ServiceProvider.getSearchUrlStateParams(),
                params: searchV2ServiceProvider.getSearchStateParamsConfig(),
                reloadOnSearch: false,
                views: {
                    'mainContent@businessPlanExplorerDefaults': {
                        templateUrl: require('./businessPlan.tpl.html'),
                        controller: 'BusinessPlanController'
                    }
                }
            });
    }
})();